<h2 mat-dialog-title>{{ data.mode === 'add' ? 'Add group' : 'Edit group' }}</h2>

<mat-dialog-content class="v2-dialog">
  <mat-form-field appearance="outline" class="full">
    <mat-label>Group name</mat-label>
    <input matInput [(ngModel)]="model.name">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Group ID</mat-label>
    <input matInput [(ngModel)]="model.groupId" [disabled]="data.mode === 'edit'"
           placeholder="stable key — cannot change later">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Type</mat-label>
    <mat-select [(ngModel)]="model.worker">
      <mat-option value="creditRenew">Credit Renew (periodic balance)</mat-option>
      <mat-option value="subsidyGroup">Subsidy Group (applied at checkout)</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>{{ isSubsidy() ? 'Subsidy (%)' : 'Credit amount' }}</mat-label>
    <input matInput type="number" [(ngModel)]="model.amount">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Customer (kundekort — billed)</mat-label>
    <mat-select [(ngModel)]="model.customerId">
      <mat-option value="">— none —</mat-option>
      <mat-option *ngFor="let c of data.customers" [value]="c.kundekortId">{{ c.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Invoice reference (Deres referanse)</mat-label>
    <input matInput [(ngModel)]="model.customerReference" placeholder="Leave empty to share the customer's invoice">
    <mat-hint>When set, this group's purchases are invoiced separately, with this reference.</mat-hint>
  </mat-form-field>

  <!-- Credit-Renew only: accumulate, cap, and renewal schedule -->
  <div *ngIf="!isSubsidy()" class="v2-dialog-block">
    <mat-checkbox [(ngModel)]="model.accumulate">Accumulate (roll over unused credit)</mat-checkbox>
    <mat-form-field appearance="outline" class="full" *ngIf="model.accumulate">
      <mat-label>Credit limit (max, 0 = none)</mat-label>
      <input matInput type="number" [(ngModel)]="model.creditLimit">
    </mat-form-field>

    <div class="v2-dialog-row">
      <mat-form-field appearance="outline">
        <mat-label>Hour (0–23)</mat-label>
        <input matInput type="number" min="0" max="23" [(ngModel)]="model.setHour">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Minute</mat-label>
        <input matInput type="number" min="0" max="59" [(ngModel)]="model.setMinutes">
      </mat-form-field>
    </div>
    <p class="v2-dialog-hint">Credit renews once a month, on the last day of the month at this time.</p>
  </div>

  <div class="v2-dialog-block">
    <div class="v2-dialog-label">Valid on systems (where members log in &amp; buy)</div>
    <div class="v2-dialog-systems">
      <mat-checkbox *ngFor="let s of data.systems" [checked]="hasSystem(s.systemId)"
                    (change)="toggleSystem(s.systemId)">{{ s.name }}</mat-checkbox>
      <span *ngIf="!data.systems?.length" class="v2-dialog-hint">No systems at this site.</span>
    </div>
  </div>

  <mat-checkbox *ngIf="data.mode === 'add'" [(ngModel)]="model.isTest">Mark as test group</mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="ref.close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">{{ data.mode === 'add' ? 'Add' : 'Save' }}</button>
</mat-dialog-actions>
